import React, { FC } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User, UserType } from 'api/models';

const Dot = styled.span`
  margin-right: var(--spacing-02);
`;

const AuthorName = styled.span`
  margin-right: var(--spacing-03);
`;

export const AuthorTime: FC<{
  user: User;
  createdAt?: number;
}> = ({ user, createdAt }) => {
  const intl = useIntl();

  return (
    <>
      {user.userType === UserType.External && (
        <>
          <Dot>•</Dot>
          <AuthorName>
            <FormattedMessage
              id="conversations.company"
              values={{
                companyName: user.company.companyName,
              }}
            />
          </AuthorName>
        </>
      )}
      {createdAt && <small>{intl.formatTime(createdAt)}</small>}
    </>
  );
};
